(function () {
  function hidePreloader() {
    var el = document.getElementById('site-preloader');
    if (!el) return;
    el.classList.add('is-hidden');
    setTimeout(function(){ el.remove(); }, 450);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var el = document.getElementById('site-preloader');
    if (!el) return;

    // 只显示一次（同一会话）
    if (el.classList.contains('is-once')) {
      try {
        var key = 'fuja_preloader_seen';
        if (sessionStorage.getItem(key) === '1') {
          el.remove();
          return;
        }
        sessionStorage.setItem(key, '1');
      } catch (e) {}
    }

    // 页面资源加载完成隐藏
    window.addEventListener('load', hidePreloader);

    // 兜底：防止某些资源卡住导致一直不消失
    setTimeout(hidePreloader, 5000);
  });
})();